export const ANALYTICS_EVENTS = {
	POST_VIEWED: "post_viewed",
} as const;

export const ANALYTICS_GROUP_TYPES = {
	COMMUNITY: "community",
} as const;

export type AnalyticsEvent = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
export type AnalyticsGroupType = (typeof ANALYTICS_GROUP_TYPES)[keyof typeof ANALYTICS_GROUP_TYPES];
